import { useState, useEffect, useCallback } from 'react';
import { checkAllLocationsExpiration } from '../services/expirationMonitor';

export function useExpirationCheck(checkInterval = 5 * 60 * 1000) {
  const [expirationData, setExpirationData] = useState({});
  const [loading, setLoading] = useState(true);
  const [lastUpdated, setLastUpdated] = useState(null);

  const checkExpirations = useCallback(async () => {
    try {
      setLoading(true);
      const data = await checkAllLocationsExpiration();
      setExpirationData(data);
      setLastUpdated(new Date());
    } catch (error) {
      console.error('Error checking expirations:', error);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    // Initial check
    checkExpirations();

    // Set up periodic checking
    const interval = setInterval(() => {
      checkExpirations();
    }, checkInterval);

    return () => clearInterval(interval);
  }, [checkExpirations, checkInterval]);

  return {
    expirationData,
    loading,
    lastUpdated,
    refresh: checkExpirations
  };
}
